const filtersTabs = () => {
  const filterMenu = document.querySelector('.car-filters__tabs')
  const tabs = filterMenu.querySelectorAll('.car-filters__item')

  return {
    toggleTabs: () => {
      tabs.forEach(elem => {
        const tab = elem.querySelector('label')
        const tabContent = elem.querySelector('.car-filters__tab-content')
        const tabHeight = tabContent.clientHeight
        if (window.matchMedia('(max-width: 1023px)').matches) {
          // on mobile close all tabs
          tabContent.style.maxHeight = 0
        }
        window.addEventListener('resize', () => {
          // on resize close filter tabs
          if (window.matchMedia('(max-width: 1023px)').matches) {
            const tabHeight = tabContent.clientHeight
            tabContent.style.maxHeight = 0
          } else {
            tabContent.style.maxHeight = 'auto'
          }
        })
        // close tab on mouse leave
        elem.addEventListener('mouseleave', () => {
          if (elem.classList.contains('open')) {
            elem.classList.remove('open')
          }
        })
        tab.addEventListener('click', _ => {
          if (window.matchMedia('(max-width: 1023px)').matches) {
            if (tab.parentElement.classList.contains('open')) {
              tab.parentElement.classList.remove('open')
            } else {
              tab.parentElement.classList.add('open')
            }
          }
          if (window.matchMedia('(max-width: 1023px)').matches) {
            // on mobile open / close filter tabs
            if (tabContent.clientHeight === 0) {
              tabContent.style.maxHeight = `${tabHeight}px`
            } else {
              tabContent.style.maxHeight = 0
            }
          } else {
            // on desktop open / close filter tabs
            tabs.forEach(el => {
              if (el.classList.contains('open')) {
                el.classList.remove('open')
              } else {
                if (el === elem && !elem.classList.contains('open')) {
                  elem.classList.add('open')
                }
              }
            })
          }
        })
      })
    }
  }
}
export default filtersTabs
